import { render, staticRenderFns } from "./DrugINN.vue?vue&type=template&id=7c19e035&"
import script from "./DrugINN.vue?vue&type=script&lang=js&"
export * from "./DrugINN.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports